module.exports = __webpack_public_path__ + "static/media/dentist02.bf01f332.jpg";